namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.panel()
    export class IsStockReceiveTab extends Serenity.WizardDialog<IcStockReceiveRow, any> {
        protected getFormKey() { return IcStockReceiveForm.formKey; }
        protected getLocalTextPrefix() { return IcStockReceiveRow.localTextPrefix; }

        protected form = new IcStockReceiveForm(this.idPrefix);

        constructor() {
            super();

            //this.dialogTitle = "Mode : NEW";
            let helpPopover = new J.HelpPopover(this.form, this.getPropertyItems(), "i-am-a-class").init();

            this.form.DocNo.change(e => {

                var isNewDocNo = this.isNewDocNo;
                var isExistingDocNo = this.isExistingDoc;

                Serenity.EditorUtils.setReadOnly(this.form.DocNo, isExistingDocNo);
                Serenity.EditorUtils.setRequired(this.form.DocNo, !isExistingDocNo);

                // open dropdown when existing product radio button is clicked
                if (!isNewDocNo) {
                    setTimeout(() => {
                        //(this.form.ExistingArticleCode.element as any).select2('open');
                    }, 0);

                }
                else if (!isExistingDocNo) {
                    setTimeout(() => {
                        (this.form.DocNo.element as any).select2('open');
                    }, 0);

                    this.form.DocNo.changeSelect2(e => {
                        var docno = Q.toId(this.form.DocNo.value);
                        if (docno != null) {
                            //this.form.ExistingArticleCode.value = CsSkuRow.getLookup().itemById[existingsku].ArticleCode;
                            //this.form.SysDocNo.value = IcStockReceiveRow.getLookup().itemById[docno].DocNo;
                            //this.form.DocNo.value = IcStockReceiveRow.getLookup().itemById[docno].DocNo;
                        }
                    });
                }

            });


        }

        private get isNewDocNo() {
            return this.form.DocNo.value != Inventory.ReceiveDocType.New.toString();
        }

        private get isExistingDoc() {
            return this.form.DocNo.value != Inventory.ReceiveDocType.ExitstingDoc.toString();
        }

        /**
         * next method is called when user tries to go forward
         * @param toStep the step user is trying to move to, usually one step ahead
         */
        protected next(toStep: number) {
            if (toStep == ReceiveTabSteps.Tab1Selection) {

                if (!this.isExistingDoc) {
                    toStep = ReceiveTabSteps.Tab2Selection;
                }
            }

            // you should call setStep after validating / modifying target step (toStep)
            this.step = toStep;
        }

        protected back(toStep: number) {
            if (!this.isExistingDoc) {
                // if using existing product, skip back to first step
                toStep = ReceiveTabSteps.Tab2Selection;
            }
            else if (toStep == ReceiveTabSteps.Tab2Selection &&
                !this.isExistingDoc) {
                toStep = ReceiveTabSteps.Tab1Selection;
            }
            else if (!this.isNewDocNo) {
                toStep = ReceiveTabSteps.Tab1Selection;
            }
           
            this.step = toStep;
        }

        /**
         * called to reset the form, and go back to first step
         */
        protected reset() {
            super.reset();

            // we need to clear readonly / required state of existing product selection
            // as base reset method won't reset its state, only form values
            Serenity.EditorUtils.setReadOnly(this.form.DocNo, true);
            Serenity.EditorUtils.setRequired(this.form.DocNo, false);

        }

        protected finish() {

            if (!this.isExistingDoc) {
                //console.log('New Plu');
                this.saveExistingPlu(this.form.DocNo.value);
            }
            else if (!this.isNewDocNo) {
                //console.log('New Sku Plu');
                this.saveDocNo(this.form.DocNo.value);
            }
            else {
                //console.log('all new');
                var atc = this.getSaveEntity([ReceiveTabSteps.Tab2Selection]) as IcStockReceiveRow;

                Product.SkuHdService.Create({
                    Entity: atc
                }, response => {
                    this.saveDocNo(atc.DocNo);
                });

            }
           
        }

        //ส่วนนี้ เป็นส่วนที่ Save NewPlu ----- Select SkuCode,ArticleCode มาแล้ว Save ลง Plu
        //===Select มาจาก => this.form.ExistingSkuCode.changeSelect2
        protected saveExistingPlu(docno: string) {

            //console.log('ArticleCode : ' + this.form.ExistingArticleCode.value);
            var ivtran = this.getSaveEntity([ReceiveTabSteps.Tab2Selection]);
            ivtran.DocNo = docno;
            ////skuPlu.ArticleCode = this.form.ExistingArticleCode.value;
            ////skuPlu.SizeId = this.form.SizeId.value;
            //skuPlu.SizeId = CsSkuRow.getLookup().itemById[skuCode].SizeId;
            //skuPlu.ColorId = CsSkuRow.getLookup().itemById[skuCode].ColorId;
            //skuPlu.StyleId = CsSkuRow.getLookup().itemById[skuCode].StyleId;
            //skuPlu.TasteId = CsSkuRow.getLookup().itemById[skuCode].TasteId;
            //skuPlu.MatTypeId = CsSkuRow.getLookup().itemById[skuCode].MatTypeId;
            //skuPlu.PluDesc = this.form.SkuDesc.value;
            ////skuPlu.PluShortDesc = this.form.SkuDesc.value;

            ReceiveIVService.Create({
                Entity: ivtran
            }, response => {
                Q.confirm('[ Save Receive Trans Informations ]', () => {
                    this.reset();
                }, {
                    onNo: () => this.dialogClose(),
                    onCancel: () => this.dialogClose(),
                    onClose: () => this.dialogClose()
                });
            });
        }

        /* protected getCssClass() {
            return super.getCssClass() + " s-ProductWizardDialog ";
        } */

        ////SAVE  "ArticleCode" Step 1 ต่อ 1 save form Article , Sku, Plu 
        //หรือ save แบบ ที่่มี AticleCode แล้วให้ส่งค่า มา form Sku,
        protected saveDocNo(docno: string) {

            //Save Field ArticleCode  Sku
            var ivtran = this.getSaveEntity([ReceiveTabSteps.Tab1Selection]);
            //articleSku.ArticleCode = articleCode;

            ReceiveIVService.Create({
                Entity: ivtran
            });

            console.log('DocNo : ' + this.form.DocNo.value);
            var ivtran = this.getSaveEntity([ReceiveTabSteps.Tab1Selection]);
            //articlePlu.ArticleCode = articleCode;
            //skuPlu.SkuCode = this.form.SkuCode.value;
            //skuPlu.SizeId = this.form.StyleId.value;
            //skuPlu.ColorId = this.form.ColorId.value;
            //skuPlu.SizeId = this.form.SizeId.value;
            //skuPlu.TasteId = this.form.TasteId.value;
            //skuPlu.MatTypeId = this.form.MatTypeId.value;
            //skuPlu.PluDesc = this.form.SkuDesc.value;
            //skuPlu.PluShortDesc = this.form.SkuDesc.value;

            ReceiveIVService.Create({
                Entity: ivtran
            }, response => {
                Q.confirm('[ Save Receive Trans Informations ]', () => {
                    this.reset();
                }, {
                    onNo: () => this.dialogClose(),
                    onCancel: () => this.dialogClose(),
                    onClose: () => this.dialogClose()
                });
            });
        }
    }

    export enum ReceiveTabSteps {
        Tab1Selection = 1,
        Tab2Selection = 2,
    }

    export enum ReceiveDocType {
        New = 1,
        ExitstingDoc = 2
    }
    Serenity.Decorators.registerEnumType(ReceiveDocType, 'GeniuzPOS.Inventory.ReceiveDocType', 'GeniuzPOS.Inventory.Forms.ReceiveDocType');

    export namespace ReceiveIVService {
        export const baseUrl = 'Inventory/IcStockReceive';

        export declare function Create(request: Serenity.SaveRequest<IcStockReceiveRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockReceiveRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockReceiveRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockReceiveRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = baseUrl + "/Create",
            Update = baseUrl + "/Update",
            Delete = baseUrl + "/Delete",
            Retrieve = baseUrl + "/Retrieve",
            List = baseUrl + "/List"
        }

        [
            'Create',
            'Update',
            'Delete',
            'Retrieve',
            'List'
        ].forEach(x => {
            (<any>ReceiveIVService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
